module.exports = __webpack_public_path__ + "static/media/993905.278b911f.png";